import React from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";  // Import Yup for schema validation
import { Form, Label, Input, FormGroup, Button } from "reactstrap";
import "../form.css";
import "bootstrap/dist/css/bootstrap.css";
import WorkoutApi from "../Api";

const SignUpForm = () => {
  const navigate = useNavigate();

  // Define the validation schema using Yup
  const SignupSchema = Yup.object().shape({
    username: Yup.string()
      .min(8, 'Username is too short!')
      .max(50, 'Username is too long!')
      .required('Required'),
    password: Yup.string()
      .min(8, 'Password is too short!')
      .required('Required'),
    first_name: Yup.string()
      .min(1, 'First name is too short')
      .max(50, 'First name is too long!')
      .required('Required'),
    last_name: Yup.string()
      .min(2, 'Last Name is too short!')
      .max(50, 'Too long!')
      .required('Required'),
    email: Yup.string()
      .email('Invalid email format')
      .required('Required'),
    weight: Yup.number()
      .positive('Weight must be positive')
      .required('Required'),
    height: Yup.string().required('Required'),
  });

  // Setup formik hook with initial values, validation schema, and submit handler
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      first_name: "",
      last_name: "",
      email: "",
      weight: "",
      height: "",
    },
    validationSchema: SignupSchema,  // Pass validation schema here
    onSubmit: async (values) => {
      try {
        const result = await WorkoutApi.registerUsers({ user: { ...values } });
        if (result.success) {
          // Store data in localStorage
          window.localStorage.setItem("token", result.token);
          window.localStorage.setItem("user", JSON.stringify(result.user));
          navigate("/");
        } else {
          console.debug(result.errors);
        }
      } catch (error) {
        console.log('Error occurred during registration', error);
      }
    },
  });

  return (
    <>
      <h2> Sign-up</h2>
      <h3 className="formHeader">
        Register to start planning your workouts today!
      </h3>
      <Form className="formBody" onSubmit={formik.handleSubmit}>
        <FormGroup>
          <Label className="labelTitle" htmlFor="username">Username</Label>
          <Input
            id="username"
            name="username"
            placeholder="Place Your Username Here"
            type="text"
            value={formik.values.username}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.username && formik.errors.username ? (
            <div className="error">{formik.errors.username}</div>
          ) : null}
        </FormGroup>

        <FormGroup>
          <Label className="labelTitle" htmlFor="password">Password</Label>
          <Input
            id="password"
            name="password"
            placeholder="Place Your Password Here"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="error">{formik.errors.password}</div>
          ) : null}
        </FormGroup>

        <FormGroup>
          <Label className="labelTitle" htmlFor="first_name">First Name</Label>
          <Input
            id="first_name"
            name="first_name"
            placeholder="Place Your First Name Here"
            type="text"
            value={formik.values.first_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.first_name && formik.errors.first_name ? (
            <div className="error">{formik.errors.first_name}</div>
          ) : null}
        </FormGroup>

        <FormGroup>
          <Label className="labelTitle" htmlFor="last_name">Last Name</Label>
          <Input
            id="last_name"
            name="last_name"
            placeholder="Place Your Last Name Here"
            type="text"
            value={formik.values.last_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.last_name && formik.errors.last_name ? (
            <div className="error">{formik.errors.last_name}</div>
          ) : null}
        </FormGroup>

        <FormGroup>
          <Label className="labelTitle" htmlFor="email">Email</Label>
          <Input
            id="email"
            name="email"
            placeholder="Place Your Email Here"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="error">{formik.errors.email}</div>
          ) : null}
        </FormGroup>

        <FormGroup>
          <Label className="labelTitle" htmlFor="weight">Weight</Label>
          <Input
            id="weight"
            name="weight"
            placeholder="Place Your Weight in lb. Here"
            type="number"
            value={formik.values.weight}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.weight && formik.errors.weight ? (
            <div className="error">{formik.errors.weight}</div>
          ) : null}
        </FormGroup>

        <FormGroup>
          <Label className="labelTitle" htmlFor="height">Height</Label>
          <Input
            id="height"
            name="height"
            placeholder="Place Your Height Here"
            type="text"
            value={formik.values.height}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.height && formik.errors.height ? (
            <div className="error">{formik.errors.height}</div>
          ) : null}
        </FormGroup>

        <Button color="primary" type="submit">Submit</Button>
      </Form>
    </>
  );
};

export default SignUpForm;
